export enum APIResponseType {
  Success = 1,
  Error = 2,
  Failed = 3,
  InvalidLogin = 4,
  NotAvailable = 5,
}
